import { render, staticRenderFns } from "./StockSentimentsPanel.vue?vue&type=template&id=5a056d22&scoped=true&"
import script from "./StockSentimentsPanel.vue?vue&type=script&lang=js&"
export * from "./StockSentimentsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StockSentimentsPanel.vue?vue&type=style&index=0&id=5a056d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a056d22",
  null
  
)

export default component.exports